<script setup lang="ts">
import type { PrimitiveProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import type { ButtonVariants } from "."
import { Loader2 } from "@lucide/vue"
import { Primitive } from "reka-ui"
import { cn } from "@/lib/utils"
import { buttonVariants } from "."

interface Props extends PrimitiveProps {
  variant?: ButtonVariants["variant"]
  size?: ButtonVariants["size"]
  class?: HTMLAttributes["class"]
  /** Declared (not a fallthrough attr) so `loading` can't be overridden by `:disabled="false"`. */
  disabled?: boolean
  /** Shows a spinner, sets aria-busy and blocks clicks and keys until the work is done. */
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  as: "button",
})
</script>

<template>
  <Primitive
    data-slot="button"
    :data-variant="variant"
    :data-size="size"
    :data-loading="loading ? '' : undefined"
    :aria-busy="loading ? true : undefined"
    :disabled="disabled || (loading && !asChild) || undefined"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size }), loading && 'pointer-events-none', props.class)"
  >
    <Loader2 v-if="loading && !asChild" class="animate-spin" aria-hidden="true" />
    <slot />
  </Primitive>
</template>
